export default __webpack_public_path__ + "static/media/Background_00026.59c7c345.png";